module.exports = __webpack_public_path__ + "img/default-zs.211efe09.png";